var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0037 12.7983C21.0037 17.771 16.9726 21.8021 12 21.8021",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 12.7982C2.99609 7.82555 7.02721 3.79443 11.9998 3.79443",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 12.7981C2.99623 13.8527 3.18381 14.8989 3.55008 15.8879C3.71759 16.3473 4.18986 16.6208 4.67165 16.5376L5.65825 16.3637C6.45566 16.2231 6.99772 15.4752 6.88321 14.6736L6.58627 12.595C6.52878 12.1926 6.31051 11.8308 5.98139 11.5922C5.65227 11.3537 5.24046 11.2589 4.84015 11.3294L3.07883 11.64",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0037 12.7982C21.0037 7.82555 16.9726 3.79443 12 3.79443",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0039 12.7981C21.0038 13.8527 20.8162 14.8989 20.4499 15.8879C20.2824 16.3473 19.8102 16.6208 19.3284 16.5376L18.3418 16.3637C17.5444 16.2231 17.0023 15.4752 17.1168 14.6736L17.4138 12.595C17.4713 12.1926 17.6895 11.8308 18.0186 11.5922C18.3478 11.3537 18.7596 11.2589 19.1599 11.3294L20.9212 11.64",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4943 13.2896C13.4913 13.2896 13.4886 13.2914 13.4874 13.2942C13.4863 13.297 13.4869 13.3002 13.4891 13.3024C13.4912 13.3045 13.4944 13.3052 13.4972 13.304C13.5 13.3028 13.5018 13.3001 13.5018 13.2971C13.5019 13.2951 13.5012 13.2931 13.4998 13.2917C13.4983 13.2902 13.4964 13.2895 13.4943 13.2896",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.507 13.2921C10.504 13.2921 10.5013 13.2939 10.5001 13.2967C10.499 13.2995 10.4996 13.3027 10.5018 13.3048C10.5039 13.307 10.5071 13.3076 10.5099 13.3064C10.5127 13.3053 10.5145 13.3025 10.5145 13.2995C10.5146 13.2975 10.5139 13.2955 10.5125 13.2941C10.511 13.2927 10.5091 13.2919 10.507 13.2921",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportV2);
export default __webpack_public_path__ + "static/media/SupportV2.3dea202a730be91f03a8ad52fea7a131.svg";
export { ForwardRef as ReactComponent };